import { useState } from "react";
import { Label } from ".";
import { useAlert, useApi } from "../../hooks";
import _ from "lodash";
import AsyncSelect from "react-select/async";
import constants from "../../utils/constants";

export default function AccountTypeahead({value, onChange}) {

  const { post, fetch } = useApi();
  const alert = useAlert();  
  const [inputValue, setInputValue] = useState("");

  const loadAccounts = (typedValue, callback) => {
    if (!typedValue || !typedValue.length || typedValue.length < 2) {
      return;
    }

    post("Admin/AccountTypeahead", {Name: typedValue, isExact: false, pageSize: constants.DISPLAY_PER_PAGE })
    .then((response) =>  {
      callback(response)
    })
    .catch(() => {
      alert("Server error", "Could not retrieve account(s)", "error");
      callback([]);
    });

  }

  return (
    <>
      <Label label={"Account"} />
      <AsyncSelect 
      loadOptions={loadAccounts}
      onInputChange={(e) => setInputValue(e)}
      onChange={onChange}
      noOptionsMessage={() => (!inputValue || inputValue.length <= 1) ? "Start typing to search for accounts" : "No accounts found"}
      value={value}
      isClearable
      className="mt-1"
      />
    </>
  );
}